<script>

    import layer from "@/mixins/mapboxLayer"

    import along from '@turf/along' 

    export default{

        mixins:[layer],
        
        name:"labelplanejamento",

        props:["trecho","runner"], 

        data(){
            return {
                nameLayerFromData:"planejamentolabel"
            }
        },

        created () {
            this.nameLayerFromData = "planejamentolabel"+_.get(this,'trecho.properties.numero',_.uniqueId('planejamento'));
        },


        computed:{
            geoJSON:function(){
                    var point =  along(this.trecho,this.trecho.properties.distance/2,{units:'kilometers'});
                    point.properties.name=this.runner.name;
                  
                    debugger;
                    // return point;

                   return {
                    "type": "FeatureCollection",
                    "features": [point]
                }
            },
        },

        watch:{
            geoJSON:function(){
                this.animateLine(1, true)
            }
        },

        beforeDestroy:function(){
            
        },

        methods:{

        },

        style: function () {
            var color = this.runner.color
            return {
                "type": "symbol",
                // "source": this.sourceName,
                "layout": {
                    "text-field": "{name}",
                    "text-allow-overlap":true,
                    "text-ignore-placement":true,

                    "text-anchor": "center",
                    "text-line-height": 1,
                    "text-optional": false,
                    "text-offset": {
                        "base": 1,
                        "stops": [
                            [10, [0,0]],
                            [14, [0,0]]
                        ],
                    },
                    "text-padding": 0,
                    "text-size": {
                        "base": 1,
                        "stops": [
                            [10, 12],
                            [14, 18]
                        ],
                    },
                },
                "paint": {
                    "text-color": "white",
                    "text-halo-color": color,
                    "text-halo-width": 2,
                    "text-halo-blur": 0,
                    "text-opacity": {
                        "base": 1,
                        "stops": [
                            [9, 1],
                            [13, 1]
                        ],
                    },
                   
                }
            }
        }
        }



</script>